import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  addBelow: {
    id: 'studio.TL9d+v',
    defaultMessage: 'Add a new item at position {index}',
  },
  addTop: {
    id: 'studio.PKzT+n',
    defaultMessage: 'Add a new item to {name}',
  },
  removeAbove: {
    id: 'studio.8ipOLI',
    defaultMessage: 'Remove item {name}',
  },
  swap: {
    id: 'studio.BUG3UD',
    defaultMessage: 'Swap the items above and below',
  },
  cancel: {
    id: 'studio.47FYwb',
    defaultMessage: 'Cancel',
  },
  title: {
    id: 'studio.4R9ol2',
    defaultMessage: 'Removing item',
  },
  body: {
    id: 'studio./5gKvH',
    defaultMessage: 'Are you sure you want to remove this item? This cannot be reverted.',
  },
  confirm: {
    id: 'studio.G/yZLu',
    defaultMessage: 'Remove',
  },
});
